// Session-level cache for the FULL manager-stores list (getManagerStores with
// name=""), keyed by merchant_id. Multiple components (Main, dashboards, the
// date-range filters) fetch the same full list independently; this dedupes
// those network calls within a session.
//
// IMPORTANT: only use this for the full-list call. Store SEARCH calls (name=<input>
// from the AsyncSelect dropdowns) must bypass this and hit the API directly,
// otherwise typed searches would return the cached full list.
//
// Keyed by merchant_id so switching merchant/store fetches a fresh list. The
// cache lives until a full page reload (or clearManagerStoresCache()).

const cache = new Map(); // String(merchant_id) -> Promise<axiosResponse>

/**
 * Returns a cached promise for the full manager-stores response for this
 * merchant, invoking `fetcher` (which must return the axios POST promise) only
 * on the first call per merchant_id. Failures are never cached.
 *
 * @param {string|number} merchantId
 * @param {() => Promise<any>} fetcher
 * @returns {Promise<any>} the axios response (same object shape the API returns)
 */
export const getManagerStoresCached = (merchantId, fetcher) => {
  const key = String(merchantId ?? "");
  const existing = cache.get(key);
  if (existing) return existing;
  console.log('cache', cache);

  const promise = Promise.resolve()
    .then(fetcher)
    .catch((err) => {
      cache.delete(key); // don't cache a failed request
      throw err;
    });

  cache.set(key, promise);
  return promise;
};

/** Clear the whole cache (e.g. on logout). */
export const clearManagerStoresCache = () => cache.clear();
